export default __webpack_public_path__ + "static/media/BattlyA.c9731121.gif";